import React from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  buttonProgress: {
    color: '#FFF',
  },
}));

const Button = styled.button`
  background: ${props => props.warning ? '#f44336' : props.theme.button.background};
  border: none;
  border-radius: ${props => props.theme.button.borderRadius};
  color: ${props => props.theme.button.color};
  cursor: pointer;
  display: block;
  font-size: 0.9375rem;
  font-weight: 600;
  height: 44px;
  margin: 32px 0 0 0;
  padding: 12px 18px;
  position: relative;
  transition: 0.2s ease all;
  opacity: ${props => props.disabled ? '0.6' : '1'};

  &:hover {
    opacity: 0.8;
  }

  &:focus {
    outline: none;
  }

  @media(max-width: 900px) {
    font-size: .875rem;
    height: 40px;
  }
`;

const ButtonComponent = (props) => {
  const classes = useStyles();
  return (
    <Button
      className={props.className}
      disabled={props.disabled}
      error={props.error}
      id={props.name}
      name={props.name} 
      onClick={props.onClick}
      value={props.value}
      type={props.type}
      warning={props.warning}
      boolean={props.boolean}
      ref={props.ref}
      style={props.style}
    >
      {props.isLoading ? 
        <CircularProgress className={classes.buttonProgress} size={18} />
      :
        props.label
      }
    </Button>
  )
}

ButtonComponent.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  isLoading: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string,
  type: PropTypes.string,
};


export default ButtonComponent